export default "__VITE_ASSET__CNX8CUKy__"